import types from "../types/auth";

const emptyInitialState: any = {
  auth: {
    value: null,
    loading: false,
    loaded: false,
  },
};

const initialState = emptyInitialState;

export const userReducer = (state = initialState, action: any) => {
  //console.log('entra a guardar user', action.type);
  switch (action.type) {
    case types.USER_TOKEN: {
      const user = action.payload.user;     
      return {
        ...state,
        can_access: true,
        user,
      };
    }
    case types.auth.default: {
      return {
        ...state,
        auth: { ...state.auth, loading: true },
      };
    }
    case types.auth.success: {
      return {
        ...state,
        auth: {
          ...state.auth,
          value: action.payload?.results || [],
          loading: false,
          loaded: true,
        },
      };
    }
    case types.auth.fail: {
      return {
        ...state,
        auth: {
          ...state.auth,
          loading: false,
          loaded: false,
          value: emptyInitialState.auth.value,
        },
      };
    }
    default:
      return state;
  }
};
